import React from "react";

const ShowHide = ({ children, isVisible }) => {
  return <div style={{ display: isVisible ? "block" : "none" }}>{children}</div>;
};

ShowHide.propTypes = {};

export default ShowHide;
